import * as THREE from 'three';
import {
  CARD1Web,
  MouseAction
} from '../CoordUtils.js';

import {
  BaseDrawer
} from "@/drawings3D/modelDrawing/BaseDrawer"


export class ModelDrawer extends BaseDrawer {
  constructor(model, sceneManager) {
    super(sceneManager);
    this.model = model;
    this.model.ownerDrawer = this;
    if(this.model.geometry != undefined){
      this.model.geometry.ownerDrawer = this;
    }
    this.updateGeometryOwner();
  }

  draw() {

  }

  updateGeometryOwner(){
    this.model.children.map(item => {
      item.geometry.ownerDrawer = this;
    });
  }
  doSelect(intersect, action, web3DVue) {
      var that = this;
      if(!this.sceneManager.activeCamera.hasRegEvent("ModelRClick")){
          // console.log('执行')
          this.sceneManager.activeCamera.regCameraPosChanged("ModelRClick", function(){
          var pos  = that.sceneManager.getScreenPos(that.model.position);
              $('#modelModifiPanel').css("top",pos.y).css("left", pos.x);
          });  
      }
      
      var x = event.clientX;
      var y = event.clientY;
     var that = this;
    if (action.mouse == MouseAction.CLICK) {

      if (this.sceneManager.currentMouseMovementAction.model) {
        this.sceneManager.fixModelAtPos(intersect.point);
      } else {
        // console.log('当前模型',this.model);
        if (this.model.oInfo.panel){
          let modelInfo={uuid:this.model.uuid,};
          modelInfo={...modelInfo,...this.model.oInfo};
          web3DVue.showPanel(modelInfo);
          this.model.openPanel=true;
          this.sceneManager.geometryManager.targetModel=this.model;
        }
   
      }

    } else if (action.mouse == MouseAction.RIGHTCLICK) {
      // console.log('当前模型',this.model)
      if(this.model.oInfo&&this.model.oInfo.rightClick){
          $('#modelModifiPanel').show();
          $('#modelModifiPanel').css("top", y).css("left", x);
          web3DVue.$refs.modelModificationPanel.activeObject = this.model;
      }
    }
    if(this.model.oSelect){
        if(this.sceneManager.outlinePassGreen.selectedObjects.length===0){
              this.sceneManager.outlinePassGreen.selectedObjects.push(this.model); 
        }
    }else{
       // if(this.model.oInfo&&this.model.oInfo.type=='monitor'&&!this.sceneManager.pointLabel){
       //       this.sceneManager.geometryManager.showModelTips(this.model,this.model.oInfo.name);
       // }
       if(this.model.oInfo.hover&&!this.sceneManager.pointLabel){
             this.sceneManager.geometryManager.showModelTips(this.model,this.model.oInfo.name);
       }
       this.changeToSelectedColor();
    }

  }

  changeToSelectedColor(){

        this.model.traverse(function(child) {
          if (child instanceof THREE.Mesh) {
            if (child.material.length){
              var cd = child;
              child.material.map(item => {
              item.transparent = true;
              if (item.unselectColor == undefined){
                item.unselectColor = item.color.clone();  
              }
              item.color = new THREE.Color( 0xff0000 );
            }) 
            }
            else{
              if (child.material.unselectColor == undefined){
                child.material.unselectColor = child.material.color.clone();  
              }
              child.material.color = new THREE.Color( 0xff0000 );
               child.material.transparent = true;
                
            }
            
          }
        });

  }

    changeToUnSelectedColor(){

        this.model.traverse(function(child) {
          if (child instanceof THREE.Mesh) {
            if (child.material.length){
              child.material.map(item => {
              item.transparent = true;
              item.color = item.unselectColor; 
            })  
            }
            else{
              child.material.color = child.material.unselectColor; 
               child.material.transparent = true;
                
            }
            
          }
        });
  }

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/ModelDrawer.js